import React from 'react';
import Reflux from 'reflux';
import { Popover, Overlay } from 'bootstrap';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import PopoverActions from 'flux/actions/PopoverActions';
import PopoverStore from 'flux/stores/PopoverStore';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import classNames from 'classnames';
// import mobileCheck from 'shared/lib/mobileCheck';
import { StandAlone as StandAloneTimePicker } from 'shared/components/pickers/timePicker.jsx';
import TimeUtil from 'time';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import TimeInfoIcon from './timeInfoIcon.jsx';
// const isMobile = mobileCheck();

/**
 * Start Time Picker for cuesheet start time cell
 *
 */
const StartTimePickerPopover = React.createClass({
  mixins: [Reflux.connect(PopoverStore, 'popoverVisibility'), PureRenderMixin],

  displayName: 'CuesheetStartTimeInput',

  propTypes: {
    rowIndex: React.PropTypes.number,
    className: React.PropTypes.string,
    title: React.PropTypes.string,
    twentyFour: React.PropTypes.bool,
    value: React.PropTypes.number.isRequired, //Used only to initialize internal state
    idSuffix: React.PropTypes.string,
    displayStartTimeClock: React.PropTypes.bool,
    startOnInReverse: React.PropTypes.bool,
    showResetButton: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      twentyFour: false,
    };
  },

  getInitialState() {
    return {
      value: this.props.value,
      valueChanged: false,
    };
  },

  componentWillReceiveProps(nextProps) {
    if (this.state.value !== nextProps.value && !this.state.valueChanged) {
      this.setState({ value: nextProps.value });
    }
  },

  render() {
    return (
      <div
        className="input-time-wrapper"
        id={this.props.idSuffix}
        ref={(el) => {
          this.trigger = el;
        }}
      >
        {this.props.displayNode}
        {this._getTimePickerNode()}
      </div>
    );
  },

  _getPopoverId() {
    const { rowIndex } = this.props;
    return `${EditableCellTypes.ItemStartTime}${rowIndex}`;
  },

  _isPopoverVisible() {
    return this.state.popoverVisibility.get(this._getPopoverId());
  },

  _getTimePickerNode() {
    const {
      // id,
      // showResetButton,
      simple,
    } = this.props;

    const { value } = this.state;

    return (
      <Overlay
        placement={'left'}
        rootClose
        show={this._isPopoverVisible()}
        target={this.trigger}
        onHide={() => {
          /**
           * checks if the time has actually changed
           * if it has allow manual time if not do nothing
           */

          if (this.props.value === this.state.value) {
            this._handleClose(true);
          } else {
            this._handleClose();
          }
        }}
        animation={false}
        autoFocus={false}
      >
        <Popover
          id={'popover-time-input-' + this.props.idSuffix}
          className={classNames('time-picker-popover', {
            'simple-cell': simple,
          })}
          autoFocus={false}
        >
          <div
            className="time-input-popover"
            onKeyDown={(e) => {
              // keyCode 27 - esc
              if (e.keyCode === 27) {
                this._handleClose(true);
              }
            }}
          >
            <StartTimePicker
              {...this.props}
              value={value}
              originalValue={this.props.value}
              hideFooter
              onChange={this._handleChange}
              onClose={this._handleClose}
              onResetClicked={this._handleReset}
              popoverId={this._getPopoverId()}
            />
          </div>
        </Popover>
      </Overlay>
    );
  },

  _handleChange(time, close) {
    this.setState({ value: time, valueChanged: true });
    if (this.props.updateOnEachChange) {
      CuesheetCellActions.saveItemTimeField(
        this.props.rowIndex,
        'startOn',
        time,
      );
    }

    // this is to make sure state updates before sending the api call
    if (close) setTimeout(this._handleClose, 200);
  },

  _handleReset() {
    const { rowIndex } = this.props;

    this.setState({ value: 0, valueChanged: true });

    CuesheetCellActions.saveItemTimeFields(rowIndex, {
      startOn: 0,
      startOnInReverse: false,
    });

    setTimeout(this._handleClose, 200);
  },

  _hideThisPopover() {
    PopoverActions.hide(this._getPopoverId());
  },

  _handleClose(escaped) {
    if (!this.state.valueChanged) return this._hideThisPopover();

    /**
     * @param escape Used to fix issue where escape persists value of changed field
     * when re-opening picker
     */
    if (escaped) {
      const { value } = this.props;
      this.setState({ value }, () => this._hideThisPopover());
    } else {
      CuesheetCellActions.saveItemTimeField(
        this.props.rowIndex,
        'startOn',
        this.state.value,
      );
    }

    this.setState({ valueChanged: false }, () => this._hideThisPopover());
  },
});

const StartTimePicker = React.createClass({
  displayName: 'StartTimePicker',

  propTypes: {
    value: React.PropTypes.number.isRequired,
    mobile: React.PropTypes.bool,
    onResetClicked: React.PropTypes.func,
    onClose: React.PropTypes.func,
    onGoalFlagUpClicked: React.PropTypes.func,
    onGoalFlagDownClicked: React.PropTypes.func,
    displayStartTimeClock: React.PropTypes.bool,
    startOnInReverse: React.PropTypes.bool,
    showResetButton: React.PropTypes.bool,
  },

  getInitialState() {
    return null;
  },

  render() {
    const {
      value,
      originalValue,
      twentyFour,
      // showResetButton,
      // mobile,
      // type
    } = this.props;

    const originalValueNode = (
      <span className="original-value">
        Was: {TimeUtil.getShorthandTimeUTC(originalValue, twentyFour)}
      </span>
    );

    return (
      <div className="text-center">
        <div className="picker-body">
          <StandAloneTimePicker
            classNames="cs-start-time-picker"
            showSeconds
            twentyFour={twentyFour}
            value={value}
            onClose={this.props.onClose}
            onChange={this.props.onChange}
          />
          {this._getCustomControlsNode()}
          <br />
          {originalValueNode} <TimeInfoIcon />
        </div>
      </div>
    );
  },

  _getCustomControlsNode() {
    const { showResetButton } = this.props;

    return (
      <span>
        {this._getToggleDisplayStartTimeClockNode()}
        {this._getGoalFlagControlsNode()}
        {showResetButton && this._getResetButtonNode()}
      </span>
    );
  },

  _getGoalFlagControlsNode() {
    // const key = 'startOnInReverse';
    const { rowIndex, startOnInReverse, value } = this.props;

    const save = (startOnInReverseValue) => {
      const changes = Object.assign(
        { startOnInReverse: startOnInReverseValue },
        { startOn: value },
      );
      CuesheetCellActions.saveItemTimeFields(rowIndex, changes);
    };
    return (
      <span>
        <Icon
          name="flag-arrow-up"
          tip={TooltipConstants.StartTimeReverseFlag}
          className={classNames({ active: startOnInReverse })}
          ours
          onClick={() => save(true)}
        />
        <Icon
          tip={TooltipConstants.StartTimeForwardFlag}
          name="flag-arrow-down"
          className={classNames({ active: !startOnInReverse })}
          ours
          onClick={() => save(false)}
        />
      </span>
    );
  },

  _getToggleDisplayStartTimeClockNode() {
    const { displayStartTimeClock } = this.props;

    //TODO: why is it called durationIcon??
    const durationIcon = displayStartTimeClock ? 'eye' : 'eye-slash';

    //TODO: class name is has duration in it?? why
    return (
      <span className="duration-picker-suppress-toggle">
        <Icon
          tip={TooltipConstants.StartTimeEyeball}
          name={durationIcon}
          onClick={() => this._toggleValue('displayStartTimeClock')}
        />
      </span>
    );
  },

  _toggleValue(key) {
    const currentValue = this.props[key];
    if (currentValue === true) PopoverActions.hide(this.props.popoverId);

    CuesheetCellActions.saveItemTimeField(
      this.props.rowIndex,
      key,
      !currentValue,
    );
  },

  _getResetButtonNode() {
    if (!this.props.originalValue) return null;

    return (
      <span className="duration-picker-reset-button">
        <Icon
          tip={TooltipConstants.StartTimeReset}
          onClick={() => this.props.onResetClicked()}
          name="undo"
        />
      </span>
    );
  },
});

export default StartTimePickerPopover;
